var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{negative: _vm.negative}},[_c('i',{class:['icon', {outline: _vm.outline}, _vm.name ]})])}
var staticRenderFns = []

export { render, staticRenderFns }